import { createTheme } from '@mui/material/styles';
import '@fontsource/gudea';

const theme = createTheme({
  palette: {
    primary: {
      main: '#f0452d', 
    },
  },
  typography: {
    fontFamily: 'Gudea', 
    button: {
      textTransform: 'none',
    },
  },
});

export default theme;
